import DeauvilleJanuary2026 from "../../components/before-after/DeauvilleJanuary2026";

const DeauvilleJanuary2026View = () => {

    return (
        <div className="before-after-deauville-january-2026">
            <DeauvilleJanuary2026/>
        </div>
    );
};

export default DeauvilleJanuary2026View;